module.exports = __webpack_public_path__ + "static/media/peepee.ccab51ba.mp4";